var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPythonAnimationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3739 13C20.4887 13 21.0435 16.8532 21.0435 16.8532L21.0534 20.8451H29.5324V22.0436H17.6856C17.6856 22.0436 12 21.3988 12 30.3639C12 39.3293 16.9626 39.0113 16.9626 39.0113H19.9242V34.8511C19.9242 34.8511 19.7646 29.8885 24.8076 29.8885H33.2172C33.2172 29.8885 37.942 29.9648 37.942 25.3221V17.6457C37.942 17.6457 38.6596 13 29.3739 13ZM24.6986 15.6845C24.899 15.6843 25.0974 15.7237 25.2826 15.8003C25.4677 15.8769 25.6359 15.9892 25.7776 16.1309C25.9193 16.2726 26.0316 16.4408 26.1082 16.6259C26.1848 16.8111 26.2242 17.0095 26.224 17.2099C26.2242 17.4103 26.1848 17.6087 26.1082 17.7938C26.0316 17.979 25.9193 18.1472 25.7776 18.2889C25.6359 18.4306 25.4677 18.5429 25.2826 18.6195C25.0974 18.6961 24.899 18.7354 24.6986 18.7353C24.4982 18.7354 24.2998 18.6961 24.1147 18.6195C23.9295 18.5429 23.7613 18.4306 23.6196 18.2889C23.4779 18.1472 23.3656 17.979 23.289 17.7938C23.2124 17.6087 23.1731 17.4103 23.1733 17.2099C23.1731 17.0095 23.2124 16.8111 23.289 16.6259C23.3656 16.4408 23.4779 16.2726 23.6196 16.1309C23.7613 15.9892 23.9295 15.8769 24.1147 15.8003C24.2998 15.7237 24.4982 15.6843 24.6986 15.6845V15.6845Z",
    fill: "url(#paint0_linear_1466_1136)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.626 47.818C38.5112 47.818 37.9564 43.9649 37.9564 43.9649L37.9465 39.973H29.4674V38.7745H41.3141C41.3141 38.7745 46.9998 39.4194 46.9998 30.454C46.9998 21.4887 42.0372 21.8067 42.0372 21.8067H39.0756V25.9668C39.0756 25.9668 39.2352 30.9294 34.1922 30.9294H25.7826C25.7826 30.9294 21.0578 30.8531 21.0578 35.4959V43.1725C21.0578 43.1725 20.3403 47.818 29.6258 47.818H29.626ZM34.3013 45.1338C34.1009 45.134 33.9025 45.0946 33.7174 45.018C33.5322 44.9414 33.364 44.8291 33.2223 44.6874C33.0806 44.5457 32.9683 44.3775 32.8917 44.1924C32.8151 44.0072 32.7758 43.8088 32.7759 43.6084C32.7757 43.408 32.8151 43.2096 32.8916 43.0244C32.9682 42.8393 33.0806 42.671 33.2223 42.5293C33.3639 42.3876 33.5322 42.2753 33.7173 42.1987C33.9025 42.1221 34.1009 42.0827 34.3013 42.0829C34.5017 42.0827 34.7001 42.1221 34.8852 42.1987C35.0704 42.2753 35.2386 42.3876 35.3803 42.5293C35.522 42.671 35.6343 42.8392 35.7109 43.0243C35.7875 43.2095 35.8268 43.4079 35.8267 43.6083C35.8268 43.8086 35.7875 44.0071 35.7109 44.1922C35.6343 44.3774 35.522 44.5456 35.3803 44.6873C35.2386 44.829 35.0704 44.9413 34.8852 45.0179C34.7001 45.0945 34.5017 45.1338 34.3013 45.1336V45.1338Z",
    fill: "url(#paint1_linear_1466_1136)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1466_1136",
    x1: 15.3635,
    y1: 16.1317,
    x2: 32.7084,
    y2: 33.3036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1466_1136",
    x1: 26.0096,
    y1: 27.1585,
    x2: 44.636,
    y2: 44.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonAnimationIcon);
export default __webpack_public_path__ + "static/media/pythonAnimationIcon.1784e379398d4a4f938a968100e5c995.svg";
export { ForwardRef as ReactComponent };